import { render, staticRenderFns } from "./createClock.vue?vue&type=template&id=f2769230&scoped=true&"
import script from "./createClock.vue?vue&type=script&lang=js&"
export * from "./createClock.vue?vue&type=script&lang=js&"
import style0 from "./createClock.vue?vue&type=style&index=0&id=f2769230&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2769230",
  null
  
)

export default component.exports